import React from 'react';
import SpinnerComponent from '../Player/Spinner';

const LOADING_STAGE_LABELS = {
  1: 'Data is being retrieved.',
  2: 'Data is being decoded.',
  3: 'Data is being transferred.',
  4: 'Ready to view.',
};

export const LoadingOverlay = ({
  isLoading,
  loadingStage,
  playerMode,
  ended = false,
}) => {
  if (ended) {
    return null;
  }

  if (playerMode === 'file') {
    return isLoading ? <SpinnerComponent className="spinner" /> : null;
  }
  if (loadingStage) {
    return (
      <div className="loading-stage-overlay">
        <SpinnerComponent className="spinner" />
        <span className="loading-stage-text">
          {LOADING_STAGE_LABELS[loadingStage]}
        </span>
      </div>
    );
  }
  if (isLoading) {
    return <SpinnerComponent className="spinner" />;
  }
  return null;
};
